import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import SmartLink from './SmartLink'

const ButtonStyled = styled(SmartLink)`
	font-size: ${props => props.theme.fontSizes.smallest};
	font-weight: ${props => props.theme.fontWeights.regular};
	color: white;
	text-align: center;
	background: ${props => props.theme.colors.main};
	padding: .5rem 1.2rem;
	border: 1px solid ${props => props.theme.colors.main};
	border-radius: 0 9rem 9rem 9rem;
	transition: ${props => props.theme.transitions.smallElements} ease;
	cursor: pointer;
	white-space: nowrap;
	display: inline-block;
	min-width: 9rem;
	
	${props => props.noMinWidth && `
		min-width: auto;
	`}

	&:hover {
		background: ${props => props.theme.colors.mainDarker};	
		border-color: ${props => props.theme.colors.mainDarker};	
		text-decoration: none;
	}
	
	${props => props.inverted && `
		color: ${props.theme.colors.main};
		background: transparent;
		
		&:hover {
			background: transparent;
			color: ${props.theme.colors.mainDarker};
		}
	`}
`

const Button = ({children, to, ...rest}) => <ButtonStyled to={to} {...rest}>
	{children}
</ButtonStyled>

Button.propTypes = {
	children: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
}

export default Button

export const QueryedButton = ({data: {link, label}, ...rest}) => <Button to={link} {...rest}>
	{label}
</Button>

export const NoInteractiveButton = (props) => {
	const ButtonElem = ButtonStyled.withComponent('div')
	return <ButtonElem {...props}/>
}

export const SubmitButton = ({children, ...props}) => {
	const ButtonElem = ButtonStyled.withComponent('input')
	return <ButtonElem value={children} type='submit' {...props}/>
}

QueryedButton.propTypes = {
	data: PropTypes.shape({
		label: PropTypes.string.isRequired,
		link: PropTypes.string.isRequired,
	}).isRequired,
}
